/* Lumiva theme runtime (cart, drawer, menu, toast, CTA scroll). No dependencies. */
(function () {
  "use strict";

  var A = window.Lumiva || {};
  var $ = function (sel, ctx) {
    return (ctx || document).querySelector(sel);
  };
  var $$ = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  };

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    cents = Number(cents) || 0;
    format = format || A.moneyFormat || "${{amount}}";
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? "," : thousands;
      decimal = decimal === undefined ? "." : decimal;
      var parts = (n / 100).toFixed(precision).split(".");
      var whole = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      );
      return whole + (parts[1] ? decimal + parts[1] : "");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount":
          return withDelims(cents, 2);
        case "amount_no_decimals":
          return withDelims(cents, 0);
        case "amount_with_comma_separator":
          return withDelims(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator":
          return withDelims(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator":
          return withDelims(cents, 2, "'", ".");
        case "amount_with_space_separator":
          return withDelims(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator":
          return withDelims(cents, 0, " ");
        default:
          return withDelims(cents, 2);
      }
    });
  }
  A.formatMoney = formatMoney;

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#LumivaToast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove("show");
    }, 2600);
  }
  A.toast = toast;

  /* ---------------- overlays (cart drawer, mobile menu) ---------------- */
  var lastFocus = null;
  function openOverlay(el, opener) {
    if (!el) return;
    lastFocus = opener || document.activeElement;
    el.classList.add("open");
    el.setAttribute("aria-hidden", "false");
    document.body.classList.add("lock");
    var panel = $(".panel", el);
    if (panel)
      setTimeout(function () {
        panel.focus ? panel.focus() : null;
      }, 30);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) {
      b.setAttribute("aria-expanded", "true");
    });
  }
  function closeOverlay(el) {
    if (!el || !el.classList.contains("open")) return;
    el.classList.remove("open");
    el.setAttribute("aria-hidden", "true");
    if (!$(".drawer.open, .mnav.open")) document.body.classList.remove("lock");
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) {
      b.setAttribute("aria-expanded", "false");
    });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openCart(opener) {
    openOverlay($("#CartDrawer"), opener);
  }
  A.openCart = openCart;
  A.openDrawer = function () {
    if ($("#CartDrawer") && A.cartType !== "page") openCart();
    else window.location.href = A.routes.cart;
  };

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape")
      $$(".drawer.open, .mnav.open").forEach(closeOverlay);
  });

  document.addEventListener("click", function (e) {
    var t = e.target;
    var opener = t.closest("[data-cart-open]");
    if (
      opener &&
      $("#CartDrawer") &&
      A.cartType === "drawer" &&
      !document.body.classList.contains("template-cart")
    ) {
      e.preventDefault();
      openCart(opener);
      return;
    }
    if (t.closest("[data-drawer-close]")) {
      closeOverlay($("#CartDrawer"));
      return;
    }
    if (t.closest("[data-menu-open]")) {
      openOverlay($("#MobileNav"), t.closest("[data-menu-open]"));
      return;
    }
    if (t.closest("[data-menu-close]")) {
      closeOverlay($("#MobileNav"));
      return;
    }
    /* anchor links in the mobile menu should close it before scrolling */
    var navLink = t.closest('#MobileNav a[href^="#"]');
    if (navLink) closeOverlay($("#MobileNav"));
  });

  /* ---------------- cart API ---------------- */
  function cartSections() {
    var ids = [];
    if ($("#CartDrawer")) ids.push("cart-drawer");
    var page = $("[data-cart-page]");
    if (page && page.dataset.section) ids.push(page.dataset.section);
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections["cart-drawer"]) {
      var doc = parser.parseFromString(sections["cart-drawer"], "text/html");
      var fresh = $("#CartDrawer .panel", doc);
      var panel = $("#CartDrawer .panel");
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      var inner = $("#CartDrawerInner", doc);
      if (inner) setCount(Number(inner.getAttribute("data-cart-count")) || 0);
    }
    var page = $("[data-cart-page]");
    if (page && sections[page.dataset.section]) {
      var pdoc = parser.parseFromString(
        sections[page.dataset.section],
        "text/html",
      );
      var pfresh = $("#MainCartInner", pdoc);
      var pcur = $("#MainCartInner");
      if (pfresh && pcur) pcur.innerHTML = pfresh.innerHTML;
    }
  }

  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      if (el.id === "CartDrawerInner") return;
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(
            data.description ||
              data.message ||
              (A.strings && A.strings.error) ||
              "Error",
          );
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* addItems(items, { silent: true }) skips opening the drawer / redirect */
  function addItems(items, opts) {
    var sections = cartSections();
    return postJSON(A.routes.cartAdd + ".js", {
      items: items,
      sections: sections.join(","),
      sections_url: window.location.pathname,
    }).then(function (res) {
      renderSections(res.sections);
      document.dispatchEvent(
        new CustomEvent("lumiva:cart-added", { detail: { items: items } }),
      );
      if (!opts || !opts.silent) afterAdd();
      return res;
    });
  }
  A.addItems = addItems;

  /* Re-render cart sections from the server (used after a bundle app rewrote the add request). */
  function refreshCart() {
    var ids = cartSections();
    if (!ids.length) return Promise.resolve();
    return fetch(
      window.location.pathname +
        "?sections=" +
        encodeURIComponent(ids.join(",")),
      { headers: { Accept: "application/json" } },
    )
      .then(function (r) {
        return r.json();
      })
      .then(renderSections);
  }
  A.refreshCart = refreshCart;

  /* cart reservation timer: one end time per session, survives drawer re-renders */
  function cartTimerTick() {
    var bar = $("[data-cart-timer]");
    if (!bar) return;
    var mins = Number(bar.getAttribute("data-minutes")) || 10;
    var end = 0;
    try {
      end = Number(sessionStorage.getItem("lv_cart_end")) || 0;
    } catch (e) {}
    var now = Date.now();
    if (!end || end <= now) {
      end = now + mins * 60000;
      try {
        sessionStorage.setItem("lv_cart_end", end);
      } catch (e) {}
    }
    var s = Math.max(0, Math.round((end - now) / 1000));
    var t = $("[data-cart-timer-t]", bar);
    if (t)
      t.textContent =
        String(Math.floor(s / 60)).padStart(2, "0") +
        ":" +
        String(s % 60).padStart(2, "0");
  }
  cartTimerTick();
  setInterval(cartTimerTick, 1000);

  function afterAdd(message) {
    if (A.cartType === "page") {
      window.location.href = A.routes.cart;
      return;
    }
    if (A.cartType === "checkout") {
      window.location.href = "/checkout";
      return;
    }
    if ($("#CartDrawer")) openCart();
    else toast(message || (A.strings && A.strings.added));
  }
  A.afterAdd = afterAdd;

  /* cart drawer upsell: pick color/size, add without closing the drawer */
  function upState(box) {
    var j = box.__up;
    if (!j) {
      try {
        j = box.__up = JSON.parse($("[data-up-json]", box).textContent);
      } catch (e) {
        return null;
      }
    }
    var on = $("[data-up-color].is-on", box),
      sz = $("[data-up-size]", box);
    var color = on ? on.getAttribute("data-up-color") : null;
    if (sz) {
      /* mark sizes that don't exist / are sold out for this color; jump to the first available one */
      var firstOk = null;
      $$("option", sz).forEach(function (o) {
        var ok = j.v.some(function (x) {
          return (
            (color === null || x.o[j.c] === color) &&
            x.o[j.s] === o.value &&
            x.a
          );
        });
        if (!o.__label) o.__label = o.textContent;
        o.textContent = o.__label + (ok ? "" : " — sold out");
        o.disabled = !ok;
        if (ok && firstOk === null) firstOk = o.value;
      });
      if (
        sz.selectedOptions[0] &&
        sz.selectedOptions[0].disabled &&
        firstOk !== null
      )
        sz.value = firstOk;
    }
    var size = sz ? sz.value : null;
    var v = j.v.filter(function (x) {
      return (
        (color === null || x.o[j.c] === color) &&
        (size === null || x.o[j.s] === size)
      );
    })[0];
    var btn = $("[data-up-add]", box);
    if (btn) {
      btn.disabled = !(v && v.a);
      btn.textContent =
        v && v.a
          ? btn.getAttribute("data-label")
          : (A.strings && A.strings.soldOut) || "Sold out";
    }
    if (v) {
      var img = $("[data-up-img] img", box);
      if (img && v.i) {
        img.src = v.i;
        img.removeAttribute("srcset");
      }
      var p = $("[data-up-price]", box);
      if (p) p.textContent = v.p;
      var c = $("[data-up-cmp]", box);
      if (c && v.cp) c.textContent = v.cp;
    }
    return v;
  }
  document.addEventListener("click", function (e) {
    var sw = e.target.closest && e.target.closest("[data-up-color]");
    if (sw) {
      var box = sw.closest("[data-cart-upsell]");
      $$("[data-up-color]", box).forEach(function (b) {
        b.classList.toggle("is-on", b === sw);
      });
      upState(box);
      return;
    }
    var add = e.target.closest && e.target.closest("[data-up-add]");
    if (add) {
      var box2 = add.closest("[data-cart-upsell]"),
        v = upState(box2);
      if (!v || !v.a) return;
      box2.classList.add("is-busy");
      addItems([{ id: v.id, quantity: 1 }], { silent: true }).catch(
        function (err) {
          box2.classList.remove("is-busy");
          toast(err.message);
        },
      );
    }
  });
  document.addEventListener("change", function (e) {
    if (e.target.matches && e.target.matches("[data-up-size]"))
      upState(e.target.closest("[data-cart-upsell]"));
  });
  function upInit() {
    $$("[data-cart-upsell]").forEach(function (b) {
      if (!b.__init) {
        b.__init = 1;
        upState(b);
      }
    });
  }
  A.upInit = upInit;
  upInit();
  new MutationObserver(upInit).observe(document.body, {
    childList: true,
    subtree: true,
  });

  var changeQueue = Promise.resolve();
  function changeLine(line, quantity, scope) {
    if (scope) scope.classList.add("is-updating");
    changeQueue = changeQueue.then(function () {
      return postJSON(A.routes.cartChange + ".js", {
        line: line,
        quantity: quantity,
        sections: cartSections().join(","),
        sections_url: window.location.pathname,
      })
        .then(function (res) {
          renderSections(res.sections);
          dropOrphanProtection();
        })
        .catch(function (err) {
          toast(err.message);
          if (scope) scope.classList.remove("is-updating");
        });
    });
    return changeQueue;
  }

  /* ---------------- shipping protection (snippets/cart-protection.liquid) ----------------
     The toggle adds/removes a hidden product. If it is the only thing left in the
     cart, it is removed automatically (data-prot-orphan holds its line key). */
  function changeKey(key, quantity) {
    return postJSON(A.routes.cartChange + ".js", {
      id: key,
      quantity: quantity,
      sections: cartSections().join(","),
      sections_url: window.location.pathname,
    }).then(function (res) {
      renderSections(res.sections);
      dropOrphanProtection();
    });
  }
  var protBusy = false;
  function dropOrphanProtection() {
    if (protBusy) return;
    var el = $('[data-prot-orphan]:not([data-prot-orphan=""])');
    if (!el) return;
    protBusy = true;
    changeKey(el.getAttribute("data-prot-orphan"), 0).then(
      function () {
        protBusy = false;
      },
      function () {
        protBusy = false;
      },
    );
  }
  A.dropOrphanProtection = dropOrphanProtection;
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-protect-input]");
    if (!input) return;
    var box = input.closest("[data-protect]");
    box.classList.toggle("is-on", input.checked);
    box.classList.add("is-updating");
    var job = input.checked
      ? addItems([{ id: Number(box.dataset.variant), quantity: 1 }], {
          silent: true,
        })
      : box.dataset.key
        ? changeKey(box.dataset.key, 0)
        : Promise.resolve();
    changeQueue = changeQueue.then(function () {
      return job.catch(function (err) {
        toast(err.message);
        input.checked = !input.checked;
        box.classList.toggle("is-on", input.checked);
        box.classList.remove("is-updating");
      });
    });
  });
  document.addEventListener("lumiva:cart-added", dropOrphanProtection);
  dropOrphanProtection();

  /* line-item controls, delegated so re-rendered markup keeps working */
  document.addEventListener("click", function (e) {
    var step = e.target.closest(".line [data-qty-step]");
    var rm = e.target.closest(".line [data-remove]");
    if (!step && !rm) return;
    e.preventDefault();
    var line = e.target.closest(".line");
    var idx = Number(line.dataset.line);
    if (rm) {
      changeLine(idx, 0, line);
      return;
    }
    var input = $("[data-line-qty]", line);
    var next = Math.max(
      0,
      (Number(input.value) || 0) + Number(step.dataset.qtyStep),
    );
    input.value = next;
    changeLine(idx, next, line);
  });
  var lineTimer;
  document.addEventListener("change", function (e) {
    var input = e.target.closest(".line [data-line-qty]");
    if (!input) return;
    var line = input.closest(".line");
    clearTimeout(lineTimer);
    lineTimer = setTimeout(function () {
      changeLine(
        Number(line.dataset.line),
        Math.max(0, Number(input.value) || 0),
        line,
      );
    }, 250);
  });

  /* ---------------- CTA scroll to buy box ---------------- */
  document.addEventListener("click", function (e) {
    var cta = e.target.closest(".js-cta, a[href='#lv-buy']");
    if (!cta) return;
    var target =
      $("#lv-buy") ||
      $("[data-section-type='main-product']") ||
      $(".shopify-section[id*='main-product']");
    if (!target) return;
    e.preventDefault();
    var head = $(".header-section");
    var off = head ? head.getBoundingClientRect().height + 12 : 12;
    var y = target.getBoundingClientRect().top + window.pageYOffset - off;
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  });

  /* ---------------- misc ---------------- */
  function initSort() {
    $$("[data-sort-select]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sel.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });
  }

  function initCountrySelects() {
    $$("select[data-default]").forEach(function (sel) {
      if (sel.dataset.default) sel.value = sel.dataset.default;
    });
  }

  /* footer country/currency selector submits the localization form */
  document.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-localization-select]");
    if (sel && sel.form) sel.form.submit();
  });

  /* lazy video posters: themes render poster as data-poster, set it when near the viewport */
  function initPosters() {
    var vids = $$("video[data-poster]");
    if (!vids.length) return;
    function show(v) {
      if (v.dataset.poster) {
        v.poster = v.dataset.poster;
        v.removeAttribute("data-poster");
      }
    }
    if (!("IntersectionObserver" in window)) return vids.forEach(show);
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            show(en.target);
            io.unobserve(en.target);
          }
        });
      },
      { rootMargin: "600px 0px" },
    );
    vids.forEach(function (v) {
      io.observe(v);
    });
  }

  function init() {
    initSort();
    initCountrySelects();
    initPosters();
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();

  window.Lumiva = A;
})();
